import React from 'react';

import { Box, Typography } from 'components';

type Props = {
  header?: string;
  subHeader?: string;
  textAlignment?: 'center' | 'left' | 'right';
  children?: React.ReactNode;
};

export const PageHeader: React.FC<Props> = ({
  header,
  subHeader,
  children,
  textAlignment,
}) => {
  return (
    <Box zIndex={10} top={0} position="sticky">
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        gap="0.5rem"
        paddingTop="0.5rem"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
      >
        <Box overflow="hidden">
          {header && (
            <Typography
              textAlign={textAlignment}
              variant="h2"
              noWrap
              sx={{
                display: 'block',
                maxWidth: '100%',
              }}
            >
              {header}
            </Typography>
          )}
          {subHeader && (
            <Typography
              textAlign={textAlignment}
              variant="subtitle1"
              noWrap
              sx={{
                display: 'block',
                maxWidth: '100%',
                paddingTop: '0.25rem',
                paddingBottom: '0.25rem',
                whiteSpace: 'normal',
              }}
            >
              {subHeader}
            </Typography>
          )}
        </Box>
        <Box width={{ xs: '100%', sm: 'auto' }} mt={{ xs: 1, sm: 0 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};
